import get from 'lodash/get';
import { defaultContent } from '~/defaultContent';

export function getBlockValue(block, key) {
  if (isTextBlock(block)) {
    return block.value;
  }

  if (isCategoriesTopicsList(block)) {
    return block.categories_topics;
  }

  if (isImage(block)) {
    return {
      image: block.image,
      link: block.link,
    };
  }

  return get(defaultContent, key);
}

function isTextBlock(block) {
  return block.component === 'text' && block.value !== '';
}

function isCategoriesTopicsList(block) {
  return block.component === 'categories_topics_list';
}

function isImage(block) {
  return block.component === 'image';
}
